"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.time = exports.scale = exports.repeat = exports.fade = exports.easing = exports.delay = exports.text = exports.spacing = exports.size = exports.opacity = exports.layout = exports.color = void 0;
var color_1 = require("./color");
Object.defineProperty(exports, "color", { enumerable: true, get: function () { return color_1.color; } });
var layout_1 = require("./layout");
Object.defineProperty(exports, "layout", { enumerable: true, get: function () { return layout_1.layout; } });
var opacity_1 = require("./opacity");
Object.defineProperty(exports, "opacity", { enumerable: true, get: function () { return opacity_1.opacity; } });
var size_1 = require("./size");
Object.defineProperty(exports, "size", { enumerable: true, get: function () { return size_1.size; } });
var spacing_1 = require("./spacing");
Object.defineProperty(exports, "spacing", { enumerable: true, get: function () { return spacing_1.spacing; } });
var text_1 = require("./text");
Object.defineProperty(exports, "text", { enumerable: true, get: function () { return text_1.text; } });
var delay_1 = require("./delay");
Object.defineProperty(exports, "delay", { enumerable: true, get: function () { return delay_1.delay; } });
var easing_1 = require("./easing");
Object.defineProperty(exports, "easing", { enumerable: true, get: function () { return easing_1.easing; } });
var fade_1 = require("./fade");
Object.defineProperty(exports, "fade", { enumerable: true, get: function () { return fade_1.fade; } });
var repeat_1 = require("./repeat");
Object.defineProperty(exports, "repeat", { enumerable: true, get: function () { return repeat_1.repeat; } });
var scale_1 = require("./scale");
Object.defineProperty(exports, "scale", { enumerable: true, get: function () { return scale_1.scale; } });
var time_1 = require("./time");
Object.defineProperty(exports, "time", { enumerable: true, get: function () { return time_1.time; } });
//# sourceMappingURL=index.js.map